import "@pnp/polyfill-ie11"
import "regenerator-runtime/runtime.js"
import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import store from "./store"
import "./registerServiceWorker"
import "./plugins/fusioncharts.js"
import "./plugins/composition-api"
import "./plugins/toasted"
import "./plugins/v-click-outside"
import VueSlider from "vue-slider-component"
import "vue-slider-component/theme/default.css"

Vue.config.productionTip = false

Vue.component("VueSlider", VueSlider)

// Global event bus
export const bus = new Vue()

export const vue = new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app")

Vue.directive("focus", {
  // When the bound element is inserted into the DOM...
  inserted: function (el) {
    // Focus the element
    el.focus()
  }
})
